export default {
  // Acciones genéricas (botones de formulario/diálogo)
  save: 'Guardar',
  cancel: 'Cancelar',
  delete: 'Eliminar',
  edit: 'Editar',
  back: 'Regresar',

  // Respuestas genéricas de sí/no/no aplica
  yes: 'Sí',
  no: 'No',
  na: 'N/A',

  // Estado de carga
  loading: 'Cargando...',
  loading_locations: 'Cargando Ubicaciones...',
  loading_map: 'Cargando Mapa...',

  // Mensajes genéricos de UI
  'pull-message': 'Arrastrar para actualizar',

  // Campos genéricos de entidad (nombre, ubicación, rol, etc.)
  name: 'Nombre',
  location: 'Ubicación',
  role: 'Rol',
  roles: 'Roles',
  user: 'Usuario',
  users: 'Usuarios',
  franchise: 'Unidad de negocio',
  organization: 'Organización',
  password: 'Contraseña',
  password_placeholder: 'Ingresa tu contraseña',

  // Nombres de roles administrativos (selector de roles compartido)
  organization_admin: 'Administrador de Organización',
  franchise_admin: 'Administrador de Unidad de Negocio',
  franchise_supervisor: 'Supervisor de Unidad de Negocio',
  users_admin: 'Administrador de Usuarios',
  password_manager: 'Gestor de contraseñas',

  // Selectores de ubicaciones y organización
  zero_locations: 'Sin Ubicaciones.',
  locations_selected: 'Ubicaciones seleccionadas',
  all_organization: 'Toda la Organización',

  // Jerarquía de nodos (árbol de roles)
  role_info: '¿Seguro que deseas eliminar el nodo y todos sus descendientes?',
  updated_node: 'Actualizar Nodo',

  // Selector genérico de grupo/ítem (formularios)
  group: 'Grupo',
  item: 'Item',

  // Notificaciones desde mixins globales
  camera_priority_notification_title: 'Binnacle',
  camera_priority_notification_body: 'Tomando foto…',
  camera_unavailable: 'Este dispositivo no tiene una cámara disponible.',
  pick_image_source_title: 'Selección de Imagen',
  pick_image_source_message: 'Seleccione la fuente de la imagen a usar.',
  pick_image_source_camera: 'Cámara',
  pick_image_source_files: 'Archivos',

  // Alcance de permisos (organización completa / unidad de negocio / propios)
  scope_organization: 'Organización',
  scope_franchise: 'Unidad de Negocio',
  scope_own: 'Propios',

  // Campos de dirección y contacto (franquicias/ubicaciones)
  rfc: 'RFC',
  address: 'Dirección',
  folio: 'Folio',
  longitude: 'Longitud',
  latitude: 'Latitud',
  timezone: 'Zona horaria',
  timezone_adjusted: 'Zona horaria actualizada. Se ajustarán {events} actividades de agenda y {tasks} tareas de esta ubicación.',
  contact_number: 'Teléfono de contacto',

  // Gestión de grupos de ubicaciones
  add_group: 'Agregar grupo',
  add_group_prompt: 'Ingrese el nombre del grupo que desee crear',
  delete_group_prompt: '¿Desea eliminar el grupo "{group_name}"?',
  delete_location_title: 'Eliminar ubicación',
  delete_location_prompt: '¿Deseas eliminar la ubicación "{location_name}"?',
  delete_location_has_data: 'La ubicación "{location_name}" tiene información relacionada ({details}). Al eliminarla dejará de mostrarse en la plataforma, pero la información se conserva.',
  delete_location_continue: '¿Deseas continuar?',
  related_assigned_users: 'Usuarios asignados: {count}',
  related_occurrences: 'Revisiones: {count}',
  related_events: 'Eventos en agenda: {count}',
  related_tasks: 'Tareas: {count}',
  add_subgroup: 'Agregar subgrupo',
  add_subgroup_in: 'Agregar subgrupo en "{group_name}"',
  focus_group: 'Enfocar esta rama',
  all_groups: 'Todos los grupos',
  level_n: 'Nivel {level}',
  sort_groups: 'Ordenar',
  sort_alpha_asc: 'Alfabético (A-Z)',
  sort_alpha_desc: 'Alfabético (Z-A)',
  sort_custom: 'Manual (arrastrar)',
  sort_alpha_asc_short: 'A-Z',
  sort_alpha_desc_short: 'Z-A',
  sort_custom_short: 'Manual',
  sort_level_hint: 'El orden se aplica a todos los grupos de este nivel en la organización',
  sort_order_updated: 'Orden actualizado',
  sort_type_updated: 'Se actualizó el tipo de orden del nivel',
  sort_custom_required: 'Cambia el orden de este nivel a manual antes de arrastrar',
  locations: 'Ubicaciones',
  unit: 'Agregar Unidad de negocio',

  // Formulario/widget genérico (dashboard)
  form_category: 'Categoría de Formulario',
  form: 'Formulario',
  filter: 'Filtro',
  filter_action: 'Filtrar',
  clear_filters: 'Borrar Filtros',
  filter_elements: 'Filtrar los elementos',
  write_here: 'Escribir aquí',
  duplicate: 'Duplicar',
  rename: 'Renombrar',

  // Metadatos y campos de ítems (occurrences/reportes)
  task_priority: 'Prioridad: ',
  priority: 'Prioridad',
  description: 'Descripción',
  comment: 'Comentario',
  title: 'Título',
  category: 'Categoría',
  score: 'Calificación',
  incidences: 'Incidencias',
  without_result: 'Sin resultados',
  option: 'Opción',
  value: 'Valor',

  // Acciones y mensajes puntuales
  add_camp: 'Agregar Campaña',
  back_event: 'Atrás',
  close: 'Cerrar',
  irreversible_action: 'Acción irreversible',
  search: 'Buscar',
  since: 'Desde',
  organization_name: 'Nombre de la organización',

  // Agenda / eventos (probable residuo de la migración a calendar.js)
  event_user: 'Por Usuario',
  event_organization: 'Toda la Organización',
  event_guest: 'Agregar Invitados',
  event_notification: 'Enviar Notificación',
  event_desc: 'Descripción',
  tittle_event: 'Título del Evento',
  allday: 'Todo el día',
  event_perday: 'Crear un Evento por día',
  event_range: 'Rangos',
  event_break: 'Descanso',
  eventSt: 'Evento',
  week_beginning: 'Dia de inicio de semana',
  week_number: 'Mostrar numero de semana',

  // Tareas: orden y estado
  expired: 'Vencido',
  add_task: 'Agregar Tarea',
  asc: 'Ascendente',
  leftday: 'Dias restantes',
  creation: 'Creación',
  priory: 'Prioridad',
  orderby: 'Ordenar por:',
  donetasks: 'Ver tareas finalizadas',
  byme: 'Asignadas por mi',
  suspended: 'Suspendidas',
  done: 'Finalizadas',
  notdone: 'Por hacer',

  // Textos sueltos sin agrupación clara
  desc: 'Descendente',
  average: 'Promedio',
  audit: 'Auditorías',
  evidence: 'Evidencia:',
  add_coment: 'Agregue su comentario',
  select_location: 'Selecciona una Ubicación',
  task_create: 'Creados por mí',
  more: 'Más',
  plans: 'Planes',
  to_assign: 'Enviar al Auditado',
  'save-and-close': 'Guardar y Cerrar',
  'rows-per-page-label': 'Registros por página',
  all_available: 'Todas las disponibles',
  options: 'Opciones',
  values: 'Valores'
}
